export const EVENT_OPEN_ONBOARDING = "OPEN_ONBOARDING";
export const EVENT_CLOSE_ONBOARDING = "CLOSE_ONBOARDING";
